const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/sections/Arbeitgeber.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { AnstellungField } from 'App/components/eCheckin/components/fields/metakat/AnstellungField';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { valueToBoolean } from '@cistec/common_web/modules/CIS4m/utils/data';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import _ from 'lodash';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { useText } from '@cistec/common_web/utils/intlUtils';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    location: {
        maxLength: 30,
    },
};

export const Arbeitgeber = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KEINE_ANGABEN = createFieldPath(path, 'keineAngaben');
    const PATH_EMPLOYMENT = createFieldPath(path, 'employment');
    const PATH_COMPANY = createFieldPath(path, 'company');

    const formData = useCIS4mData();
    const keineAngaben = _.get(formData, PATH_KEINE_ANGABEN) === '1';
    const employment = _.get(formData, PATH_EMPLOYMENT);
    const showEmploymentDetails = ['employed', 'self-employed'].includes(employment);

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.keineAngabenArbeitgeber)}
                path={PATH_KEINE_ANGABEN}
                parseValue={valueToBoolean}
            />
            <CIS4mBlock hidden={keineAngaben}>
                <AnstellungField path={PATH_EMPLOYMENT} label={textMap.employment} required={true} />
                <CIS4mBlock hidden={!showEmploymentDetails}>
                    <CIS4mTextField label={textMap.company} path={PATH_COMPANY} required={true} maxLength={30} />
                    <AddressBlock basePath={path} fieldsConfig={addressFieldsConfig} required={true} />
                </CIS4mBlock>
            </CIS4mBlock>
        </ECheckinSection>
    );
});

Arbeitgeber.displayName = 'Arbeitgeber';

export default Arbeitgeber;
